import { useState, useEffect } from 'react';
import { fetchOrderLineItemsService as defaultService } from '../services/fetchOrderLineItemsService';

export function useFetchOrderLineItems(
  userId,
  orderReference,
  service = defaultService,
) {
  const [status, setStatus] = useState('idle');
  const [lineItems, setLineItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId || !orderReference) return;

    let cancelled = false;
    setStatus('loading');
    setLineItems([]);
    setError(null);

    service
      .fetchOrderLineItems({ userId, orderReference })
      .then(items => {
        if (!cancelled) {
          setLineItems(items);
          setStatus('success');
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err);
          setStatus('error');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [userId, orderReference, service]);

  return { status, lineItems, error };
}
